import styled from 'styled-components';

export const SelectionHeaderCellWrapper = styled.div`
  align-items: flex-end;
  display: flex;
  height: 100%;
  justify-content: center;
  width: 100%;
`;
